<template>
  <div class="container">
    <div class="item-wrapper">
      <el-input class="item" v-model="search" size="mini" placeholder="快速搜索"></el-input>
      &nbsp;&nbsp;
      <el-badge class="mark" :value="moduleList.length || 0">
        <el-tag type="success" size="mini" >总计</el-tag>
      </el-badge>
            &nbsp;&nbsp;
      <el-badge class="mark" :value="unPublished.length || 0">
        <el-tag type="danger" size="mini" >未发布</el-tag>
      </el-badge>
      &nbsp;&nbsp;
      <el-badge class="mark" :value="moduleList.length - unPublished.length || 0">
        <el-tag type="primary" size="mini" >已发布</el-tag>
      </el-badge>
      &nbsp;&nbsp;
      <el-button type="primary" size="mini" @click="getList">刷新</el-button>
    </div>
    <vvTable
      :data="moduleListByFilter"
      :config="tableConfig"
      :height="600"
    >
      <template slot-scope="scope" slot="version_desc_slot">
        {{scope.row.version_desc ? scope.row.version_desc : '-'}}
      </template>
      <template slot-scope="scope" slot="canteen_slot">
        {{findCanteen(scope.row)}}
      </template>
      <template slot-scope="scope" slot="date_slot">
        {{scope.row.add_ts | tsToDate}}
      </template>
      <template slot-scope="scope" slot="desc_slot">
        {{scope.row.desc ? scope.row.desc : '-'}}
      </template>
      <template slot-scope="scope" slot="state_slot">
        <el-tag type="success" v-if="scope.row.is_published === '1'" size="mini">已发布</el-tag>
        <el-tag type="danger" v-else size="mini">未发布</el-tag>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <!--<publishButton :moduleType="moduleType" :module_uuid="scope.row.model_uuid"></publishButton>-->
        <el-button type="text" size="mini" @click="toPublish(scope.row)">发布</el-button>
        <el-button type="text" @click="copy(scope.row.url)" size="mini">复制链接</el-button>
      </template>
    </vvTable>
    <el-dialog
      :onclose="cancel"
      title="请选择指定机器"
      :visible.sync="machineShow"
      width="600">
<!--      <el-radio v-model="otherCanteen" size="mini" :label="false">本餐厅</el-radio>-->
<!--      <el-radio v-model="otherCanteen" size="mini" :label="true">其他餐厅</el-radio>-->
<!--      <el-input v-model="searchBox" size="mini" placeholder="快速搜索"></el-input>-->
      <el-table
        @selection-change="handleSelected"
        height="300px"
        :data="machineList">
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
          width="50"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="canteen_name"
          label="餐厅"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="machine_name"
          label="机器名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="machine_id"
          label="机器ID"
        >
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmPublish" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import vvTable from 'vue-virtual-table';
import {apiGetDishModelList, apiPublishDishModel} from '@/api';
import pinyinMatch from 'pinyin-match';

export default {
  name: 'dishModelAdmin',
  components: {
    vvTable
  },
  data () {
    return {
      otherCanteen: false,
      searchBox: '',
      search: '',
      machineShow: false,
      moduleType: 3,
      moduleList: [],
      publishModel: {},
      selectedRows: []
    };
  },
  mounted () {
    this.getList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    copy (text) {
      this.$copyText(text).then((e) => {
        this.$message.success('复制成功');
      }).catch((e) => {
        this.console.log(e);
        this.$message.error('复制失败' + e);
      });
    },
    cancel () {
      this.machineShow = false;
      this.selectedRows = [];
      this.seachBox = '';
      this.otherCanteen = false;
    },
    async confirmPublish () {
      await apiPublishDishModel({
        canteen_id: this.publishModel.canteen_id,
        machine_uuid_list: this.selectedRows.map(a => a.machine_uuid),
        model_uuid: this.publishModel.model_uuid
      });
      this.$message.success('发布成功');
      this.getList();
      this.cancel();
    },
    handleSelected (rows) {
      console.log(rows);
      this.selectedRows = rows;
    },
    toPublish(row) {
      this.publishModel = row;
      this.machineShow = true;
    },
    async getList () {
      try {
        const res = await apiGetDishModelList();
        this.moduleList = res.model_info_list;
      } catch (e) {
        this.$message.error('获取碗碟模型列表失败' + e.message);
      }
    },
    findCanteen(row) {
        const canteen_id = Number(row.canteen_id);
        let res = this.$_.find(
          this.allCanteenList,
          a => a.canteen_id === canteen_id
        );
        console.log(res);
        const noCanteen = "无记录";
        if (res) {
          return res.eatery_name + ", " + res.canteen_name;
        } else {
          return "无记录";
        }
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters(['allCanteenList', 'allMachineList']),
    machineList () {
      let list = this.allMachineList;
      if (this.otherCanteen) {
        list = list.filter(a => {
          let res = pinyinMatch.match(
            a.canteen_name + "," + a.eatery_name,
            this.searchBox
          );
          return res.length > 0;
          // return canteen['canteen_name'].indexOf(search) !== -1 || canteen['eatery_name'].indexOf(search) !== -1;
        });
      } else {
        list = this.allMachineList.filter(a => a.canteen_id === Number(this.publishModel.canteen_id));
      }
      return list;
    },
    unPublished () {
      return this.moduleList.filter(a => a.is_published === '0');
    },
    moduleListByFilter () {
      let list = this.$_.cloneDeep(this.moduleList);
      let searchText = this.search;
      if (searchText) {
        list = list.filter(a => {
          const canteen = this.findCanteen(a);
          let res = pinyinMatch.match(canteen, searchText);
          // console.log(res);
          return res.length > 0;
        });
      }
      list = this.$_.orderBy(
        list,
        ["add_ts", "is_published"],
        ["desc", "asc"]
      );
      return list;
    },
    tableConfig () {
      return [
        {prop: "version", name: "版本号"},
        {prop: '_action', name: '餐厅名称', actionName: 'canteen_slot', width: 300},
        {prop: "_action", name: "更新日志", actionName: "version_desc_slot"},
        {prop: "_action", name: "上传日期", actionName: "date_slot"},
        {prop: "_action", name: "模块备注", actionName: "desc_slot"},
        {prop: "_action", name: "是否发布", actionName: "state_slot"},
        {prop: "_action", name: "操作", actionName: "event_slot", width: 200}
      ];
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
  .container {
    position: relative;
    .item-wrapper {
      position: relative;
      top: -5px;
      .item {
        width: 150px;
        display: inline-block;
      }
    }
    .header-title {
      position: absolute;
      top: -90px;
      left: 200px;
      z-index: 1000;
    }
  }
</style>
